import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';


const SelectBoxButton = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, id, type } = item;
  return (
    <>
      <div className="_selectBox_buttons_div">
        {items !== undefined &&
          items.map((tempItem, idx) => {
            return (
              <div className="_selectBox_buttons_area" key={`${id}_${idx}_area`}>
                <div key={`${id}_${idx}`} className="_button" style={boxStyle} onClick={e => onClickEvt(tempItem.button.value)}>
                  {ReactHtmlParser(tempItem?.button?.label || '')}
                  {/* {ReactHtmlParser(item.text || '')} */}
                </div>
              </div>
            );
          })}
      </div>
      
    </>
  );
};
SelectBoxButton.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
SelectBoxButton.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

export default SelectBoxButton;
